import axios from 'axios'
import URLSearchParams from 'url-search-params'
import ResourceConstants from '../constants/ResourceConstants'
const uuidv4 = require('uuid/v4');

axios.defaults.baseURL = ResourceConstants.CUSTOMER_API

const CONTENT_TYPE_FORM_ENCODED = { 'Content-Type': 'application/x-www-form-urlencoded' }
const AUTH_HEADER = token => ({'Authorization': `bearer ${ token }`})

const authApiClient = axios.create({ baseURL: ResourceConstants.AUTH_API })
const kongCustomerApiClient = axios.create({ baseURL: ResourceConstants.KONG_CUSTOMER_API })

const API = {}

API.oauthLogin = (email, password, callback) => {
  const data = new URLSearchParams()
  data.append('username', email)
  data.append('password', password)
  data.append('grant_type', ResourceConstants.GRANT_TYPE_PASSWORD)
  data.append('client_id', ResourceConstants.CLIENT_ID)

  // FYI, these are localhost for a reason. They're part of a
  // lazy auth scheme on the backend
  data.append('redirect_uri', 'http://localhost:3000/')

  return axios.post('/oauth/token', data.toString(), {
    headers: CONTENT_TYPE_FORM_ENCODED
  })
  .then(callback)
  .catch((error) => {
    callback(error.response)
    //do some more error tracking
  })
}

API.login = ({ email, password, clientId, redirectUrl, callback, cutover }) => {

  const payload = {
    email,
    password,
    clientId,
    redirectUrl
  }

  return authApiClient.post('/authenticate/code', payload)
    .then(callback)
    .catch((error) => callback(error.response))
}

API.checkEmail = (email, callback) => {
  return kongCustomerApiClient.head(`/users?email=${encodeURIComponent(email)}`)
    .then(callback)
    .catch((error) => callback(error.response))
}

API.sendReset = (email, callback) => {
  return axios.post('/users/forgot', { email })
  .then(callback)
  .catch((error)=> {
    callback(error.response)
    //do some more error tracking
  })
}

API.resetPassword = (newPassword, relayToken, callback) => {
  const newPasswordPayload = {
    newPassword,
    relayToken
  }
  return authApiClient.post(`/password/update/forgot?clientId=${ResourceConstants.DEFAULT_CLIENT_ID}&redirectUrl=${ResourceConstants.APP_ROOT}`, newPasswordPayload)
    .then(callback)
    .catch((error) => callback(error.response))
}

API.acceptInvitation = (password, token, callback) => {
  const data = new URLSearchParams()
  data.append('driftt_token', token)
  data.append('password', password)
  data.append('grant_type', ResourceConstants.ONE_TIME_TOKEN)
  data.append('client_id', ResourceConstants.CLIENT_ID)
  data.append('redirect_uri', 'http://localhost:3000/')

  return axios.post('/oauth/token', data.toString(), {
    headers: CONTENT_TYPE_FORM_ENCODED
  })
  .then(callback)
  .catch((error) => {
    callback(error.response)
    //do some more error tracking
  })
}

API.fetchCurrentUser = (token) => {
  return axios.get("/users/me", {
    headers: AUTH_HEADER(token)
  })
}

API.updateName = (userId, name, token) => {
  return axios.patch(`/users/${userId}`, { name }, {
    headers: AUTH_HEADER(token)
  })
}

API.createOrg = (email, callback) => {
  const gates = { chat: true, humane_notifications: true }
  const orgData = {
    name: email,
    email,
    gates,
    configuration : { organizationName: email }
  }

  return axios.post(`/organizations?clientId=${ResourceConstants.CLIENT_ID}`, orgData)
  .then(callback)
  .catch((error) => {
    callback(error.response)
    //do some more error tracking
  })
}

API.fetchOAuthCode = (token, clientId, redirect_uri, callback) => {
  const data = new URLSearchParams()
  data.append('response_type', 'code')
  data.append('client_id', clientId)
  data.append('response_type', 'code')
  data.append('access_type', 'offline')
  data.append('redirect_uri', redirect_uri)

  return axios.post('/oauth/auth', data.toString(), {
    headers: Object.assign(CONTENT_TYPE_FORM_ENCODED, AUTH_HEADER(token))
  })
  .then(callback)
  .catch((error) => {
    callback(error.response)
    //do some more error tracking
  })
}

API.fetchOAuthAppInfo = (clientId, callback) => {
  return axios.get(`/oauth/applications?clientId=${clientId}`)
  .then(callback)
  .catch((error) => {
    callback(error.response)
    //do some more error tracking
  })
}

const getThirdPartyLoginPayload = (code) => {
  return {
    'code' : code,
    'clientId' : ResourceConstants.DEFAULT_CLIENT_ID,
    'anonymousId' : !!window.analytics && !!window.analytics.user ? window.analytics.user().anonymousId() : uuidv4()
  }
}

API.exchangeGoogleCodeForDriftCode = (code, captureCode, captureError) => {
  const payload = getThirdPartyLoginPayload(code)
  return axios.post('google/oauth/accept', payload)
    .then(response => captureCode(response))
    .catch(error => captureError(error.response))
}

API.exchangeMicrosoftCodeForDriftCode = (code, captureCode, captureError) => {
  const payload = getThirdPartyLoginPayload(code)
  return axios.post('microsoft/oauth/accept', payload)
    .then(response => captureCode(response))
    .catch(error => captureError(error.response))
}

API.checkHyFyMigrationEligible = (email, callback, onError) => {
  return authApiClient.get(`/identity/video?email=${email}`)
    .then(callback)
    .catch(onError)
}

API.redeemMultifactorCode = (payload, callback) => {
  return authApiClient.post(`/authenticate/multifactor/redeem`, payload)
    .then(callback)
    .catch((error) => callback(error.response))
}

API.redeemMultifactorCodeCutover = (payload, callback) => {
  return authApiClient.post(`/authenticate/multifactor/redeem/cutover`, payload)
    .then(callback)
    .catch((error) => callback(error.response))
}

API.enableGoogleAuthenticator = (payload, callback) => {
  return authApiClient.post(`/google-auth/setup`, payload)
    .then(callback)
    .catch((error) => callback(error.response))
}

API.enableSMSAuth = (payload, callback) => {
  return authApiClient.post(`/sms-auth/setup`, payload)
    .then(callback)
    .catch((error) => callback(error.response))
}

API.resendCode = (payload, callback) => {
  return authApiClient.post(`/sms-auth/resend`, payload)
    .then(callback)
    .catch((error) => callback(error.response))
}

API.getRelayTokenUserInfo = (relayToken, captureError) => {
  return axios.post('/relay/info', {"token": relayToken})
    .catch(error => captureError(error))
}

export default API



// WEBPACK FOOTER //
// ./src/api/auth.js